/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadWaitlistDetails
 */
export interface PalAuthSubmissionLeadWaitlistDetails {
    /**
     * 
     */
    status_set_date?: string;
    /**
     * 
     */
    status_set_reason?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionLeadWaitlistDetails interface.
 */
export function instanceOfPalAuthSubmissionLeadWaitlistDetails(value: object): value is PalAuthSubmissionLeadWaitlistDetails {
    return true;
}

export function PalAuthSubmissionLeadWaitlistDetailsFromJSON(json: any): PalAuthSubmissionLeadWaitlistDetails {
    return PalAuthSubmissionLeadWaitlistDetailsFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadWaitlistDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadWaitlistDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'status_set_date': json['status_set_date'] == null ? undefined : json['status_set_date'],
        'status_set_reason': json['status_set_reason'] == null ? undefined : json['status_set_reason'],
    };
}

export function PalAuthSubmissionLeadWaitlistDetailsToJSON(json: any): PalAuthSubmissionLeadWaitlistDetails {
    return PalAuthSubmissionLeadWaitlistDetailsToJSONTyped(json, false);
}

export function PalAuthSubmissionLeadWaitlistDetailsToJSONTyped(value?: PalAuthSubmissionLeadWaitlistDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status_set_date': value['status_set_date'],
        'status_set_reason': value['status_set_reason'],
    };
}

